export default __webpack_public_path__ + "static/media/verify account icon.cc36ec3b.png";